import { render, staticRenderFns } from "./SheetColumnsConfig.vue?vue&type=template&id=22666c35&scoped=true&"
import script from "./SheetColumnsConfig.vue?vue&type=script&lang=js&"
export * from "./SheetColumnsConfig.vue?vue&type=script&lang=js&"
import style0 from "./SheetColumnsConfig.vue?vue&type=style&index=0&id=22666c35&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22666c35",
  null
  
)

export default component.exports